// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"d9fde96bbb79a52d","6302":"77f05567108fa4a6"}[chunkId] + ".css";
};